import React from 'react';
import { motion } from 'framer-motion';
import { Car, CreditCard, Home, Heart, Skull } from 'lucide-react';
const verticals = [{
  icon: Car,
  title: 'Auto Insurance',
  description: 'Connect with drivers actively shopping for better rates. We deliver calls from consumers ready to compare quotes and switch policies.'
}, {
  icon: CreditCard,
  title: 'Debt Settlement',
  description: 'Reach consumers seeking genuine debt relief solutions. Pre-qualified leads looking for help with $10K+ in unsecured debt.'
}, {
  icon: Home,
  title: 'Home Services',
  description: 'From HVAC to roofing, plumbing to solar—we generate calls from homeowners ready to hire. Geographic targeting available.'
}, {
  icon: Heart,
  title: 'ACA Health Insurance',
  description: 'Compliant, qualified calls from consumers seeking marketplace health insurance plans. Licensed agent-ready leads during open enrollment and year-round.'
}, {
  icon: Skull,
  title: 'Final Expense Insurance',
  description: 'Compassionate connections with seniors and families planning ahead. Qualified prospects interested in burial and final expense coverage.'
}];
export function Verticals() {
  return <section className="py-20 px-6 bg-slate-50" data-id="element-48">
      <div className="max-w-7xl mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-50">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-51">
            Our Verticals
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-52">
          {verticals.map((vertical, index) => <motion.div key={vertical.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-53">
              <div className="bg-emerald-100 w-14 h-14 rounded-lg flex items-center justify-center mb-5" data-id="element-54">
                <vertical.icon className="w-7 h-7 text-emerald-600" data-id="element-55" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-56">
                {vertical.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-57">
                {vertical.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}